import React from "react";
import { Typography } from "antd";

const TabContentSection: React.SFC<{
  title: React.ReactNode;
  button?: React.ReactNode;
}> = (props) => {
  return (
    <div className="py-2 px-4">
      <div className="flex flex-row py-2">
        <Typography.Title level={4} className="flex-auto">
          {props.title}
        </Typography.Title>
        {props.button}
      </div>
      <div className="py-2">{props.children}</div>
    </div>
  );
};

export default TabContentSection;
